export default "__VITE_PUBLIC_ASSET__8d986731__"